import { getBrowserTimezone } from 'helpers/timezone.helper'
import api from '..'

export type IndividualFilters = {
  user_id_in?: number[] | null
  user_id_not_in?: number[] | null
  g?: any
}

interface Options {
  filters: IndividualFilters
  withVersions?: boolean
  onlyGeneralInfo?: boolean
}

const exportReport = (
  courseId: number,
  { filters, withVersions, onlyGeneralInfo }: Options
) => {
  return api.post(`/administration/courses/${courseId}/report`, {
    q: filters,
    withVersions,
    only_general_info: onlyGeneralInfo,
  })
}

export const exportBasicReport = (
  courseId: number,
  { filters, withVersions }: Options
) => {
  return api.post(`/administration/courses/${courseId}/individual`, {
    q: filters,
    withVersions,
    // The server renders the report activity timestamps in this zone; without
    // it the file falls back to UTC and drifts from what the screen shows.
    timezone: getBrowserTimezone(),
  })
}

export default exportReport
